import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Negara = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [negara, setNegara] = useState('')

    useEffect(() => {
        const getNegara = async () => {
            const response = await masterService.getNegaraById(id)
            setNegara(response.data.uraianNegara)
        }
        getNegara()
    }, [masterService, id])

    return (
        <>
            <div>{negara}</div>
        </>
    )
}

export default Negara